export default __webpack_public_path__ + "static/sfb-logo-de-864ceab4dac116c5d18f57ae0c96cbe6.png";